export default __webpack_public_path__ + "static/media/compliance-2021.2b00be5b.jpg";